import { SET_PACKAGES } from '../actions/types';

export default function packages(state = [], action) {
	if (!action.error && action.payload) {
		switch (action.type) {
			case SET_PACKAGES:
				return action.payload;

			// no default
		}
	}

	return state;
}



// WEBPACK FOOTER //
// ./src/reducers/packages.js